module.exports = __webpack_public_path__ + "img/footer-gh.c110485a.png";